import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      - Ŝajne, ni samvojas! – diris la Spliteto, enigante sin en la plandon. 
      – Kiel gaje esti en bona kompanio!
    </p>
    
    <p class="mb-3">
      Sentinte doloron, la knabo eksaltis sur unu gambo.
    </p>
    
    <p class="mb-3">
      - Nu jen, mi diris ja, ke en kompanio estas pli gaje!
    </p>
    `
  )
}

const itemName = {
  esp: 'La splitvundo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;